export default __webpack_public_path__ + "static/summer_bowls-269094ee53d6713e1612ece39e714289.png";